module.exports = __webpack_public_path__ + "media/images/icons/burger-b3f49afdaa769bc2cb267d590e308ae0.svg";